import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './auth'
import mitre from './odin/store_mitre.js'
import ruleCorrelation from './odin/store_rule_correlation.js'
import ruleDocumentation from './odin/store_rule_documentation.js'
import incident from './odin/store_incident.js'
import playbook from './odin/store_playbook.js'
import utilsModule from './utils'
import VuexPersist from 'vuex-persist'


const vuexLocalPersist = new VuexPersist({
    key: 'dz',
    storage: localStorage,
    reducer: (state) => {
      return {
        auth: state.auth,
        incident: {
            alertsOpened: state.incident.alertsOpened,
            messagesOpened: state.incident.messagesOpened
        }
      }
    }
})

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        mitre,
        incident,
        ruleDocumentation,
        ruleCorrelation,
        playbook,
        auth: {
            namespaced: true,
            ...authModule
        },
        utils: {
            namespaced: true,
            ...utilsModule
        }
    },
    plugins: [vuexLocalPersist.plugin]
})
